function initFaqAccordion(container) {
  const items = container.querySelectorAll('.problem-accordion__item');

  // Create mobile modal
  let modal = container.querySelector('.problem-accordion__mobile-modal');

  if (!modal) {
    modal = document.createElement('div');
    modal.className = 'problem-accordion__mobile-modal';

    modal.innerHTML = `
      <div class="problem-accordion__mobile-modal-overlay"></div>

      <div class="problem-accordion__mobile-modal-content">
        <div class="problem-accordion__mobile-modal-body"></div>
      </div>
    `;

    container.appendChild(modal);
  }

  const modalBody = modal.querySelector(
    '.problem-accordion__mobile-modal-body'
  );

  const closeModal = () => {
    modal.classList.remove('is-open');
    document.body.classList.remove('problem-accordion-modal-open');
  };

  // Clicking outside the modal still closes it
  modal
    .querySelector('.problem-accordion__mobile-modal-overlay')
    .addEventListener('click', closeModal);

  items.forEach(item => {
    const trigger = item.querySelector('.problem-accordion__item-title');
    const content = item.querySelector('.problem-accordion__item-description');

    if (item.dataset.initialized) return;
    item.dataset.initialized = "true";

    // Desktop: open all items by default
    item.classList.add('is-open');
    content.style.overflow = 'hidden';
    content.style.height = 'auto';
    content.style.paddingBottom = '20px';

    trigger.addEventListener('click', () => {

      // =========================
      // MOBILE
      // =========================
      if (window.innerWidth <= 980) {

        // If this item's modal is already open, close it
        if (
          modal.classList.contains('is-open') &&
          modal.dataset.activeItem === item.dataset.index
        ) {
          closeModal();
          return;
        }

        // Store which item is currently open
        modal.dataset.activeItem = item.dataset.index || '';

        // Build modal content
        modalBody.innerHTML = `
          <div class="problem-accordion__mobile-modal-title">
            <h4 class="problem-accordion__item-title section-heading">
              <span>${trigger.querySelector('span')?.innerHTML || trigger.innerHTML}</span>

              ${trigger.querySelector('.icon-minus')?.outerHTML || ''}
            </h4>
          </div>

          <div class="problem-accordion__mobile-modal-description">
            ${content.innerHTML}
          </div>
        `;

        modal.classList.add('is-open');
        document.body.classList.add('problem-accordion-modal-open');

        // Make title/minus inside modal close the modal
        const modalTrigger = modalBody.querySelector(
          '.problem-accordion__item-title'
        );

        if (modalTrigger) {
          modalTrigger.addEventListener('click', closeModal);
        }

        return;
      }

      // =========================
      // DESKTOP
      // =========================
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        item.classList.remove('is-open');
        content.style.height = content.scrollHeight + 'px';

        requestAnimationFrame(() => {
          content.style.height = '0px';
          content.style.paddingBottom = '0px';
        });

      } else {
        item.classList.add('is-open');

        content.style.height = '0px';
        content.style.paddingBottom = '0px';

        requestAnimationFrame(() => {
          content.style.height = content.scrollHeight + 'px';
          content.style.paddingBottom = '20px';
        });
      }
    });

    // After opening animation, allow natural height
    content.addEventListener('transitionend', event => {
      if (
        event.propertyName === 'height' &&
        item.classList.contains('is-open')
      ) {
        content.style.height = 'auto';
      }
    });
  });

  // Assign an index to each item
  items.forEach((item, index) => {
    item.dataset.index = index;
  });
}

document.querySelectorAll('.problem-accordion').forEach(section => {
  initFaqAccordion(section);
});

document.addEventListener('shopify:section:load', function (event) {
  const section = event.target;

  if (section.classList.contains('problem-accordion')) {
    initFaqAccordion(section);
  }
});
